<template>
  <div>
    <section>
      <!-- <van-nav-bar
          title=""
          :left-text="newData.channelName"
          right-text="读报"
          left-arrow
          :border="false"
          @click-left="onClickLeft"
          @click-right="onClickRight"
      /> -->
      <van-nav-bar
        title=""
        left-arrow
        left-text="7000万人都在看"
        :border="false"
        @click-left="onClickLeft"
        style="background: #f8f8f8"
      >
        <template #right>
          <div class="top-recmm" @click="onClickRight">
            <p
              style="
                margin-right: 20px;
                color: #164a9a;
                font-size: 12px;
                padding: 0px 4px;
                border: 1px solid #164a9a;
                border-radius: 12px;
              "
            >
              精彩业务推荐
            </p>
          </div>
          <van-icon name="weapp-nav" @click="openBottomPannel" />
        </template>
      </van-nav-bar>
    </section>
    <section>
      <div class="contents" v-if="!error">
        <div v-if="loading">
          <van-skeleton title :row="5" />
        </div>

        <div v-if="!loading">
          <div class="h2subject">{{ newData.title }}</div>

          <div v-if="newData.type == 1 || newData.type == 5">
            <div v-if="newData.views > 1000" class="views">
              热度：{{ newData.views }}
            </div>

            <div class="thread-star">
              <div class="time">
                <div class="scsjb_info">
                  <div class="author">
                    <van-image
                      round
                      src="/img/logo-500.jpg"
                      class="dlogo"
                    ></van-image>
                  </div>
                  <div class="user_info">
                    <div class="n">
                      四川手机报/{{ newData.channelName }}
                      <a
                        :href="'/special/' + newData.topicId"
                        v-if="newData.topicId != ''"
                        >/专题:{{ newData.topicTitle }}</a
                      >
                    </div>
                    <div class="t">
                      {{ today }}
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div class="mode">
                <div class="fontSize" @click="setfontSize(1)">
                  <i class="iconfont icon-yueduye_zitizengda"></i>
                </div>
                <div class="fontSize" @click="setfontSize(2)">
                  <i class="iconfont icon-yueduye_zitijianxiao"></i>
                </div>
              </div> -->
            </div>
            <div v-if="newData.type == 5">
              <video
                :src="newData.video"
                style="width: 100%; margin-top: 10px; object-fit: cover;"
                controls="controls"
                :poster="newData.videoImg"
              ></video>
            </div>
            <div
              class="message"
              :style="{ fontSize: fontSize + 'px' }"
              v-html="newData.content"
            ></div>
            <div
              class="origin"
              v-if="newData.origin !== ''"
              :style="{ fontSize: fontSize + 'px' }"
            >
              来源：{{ newData.origin }}
            </div>
          </div>

          <div v-if="newData.type == 3">
            <div class="thread-star">
              <div class="time">
                {{ newData.publishTime }}
              </div>
            </div>
            <div class="photocentent" style="margin-top: 20px">
              <div class="imgs" v-for="(item, k) in newData.content" :key="k">
                <van-image :src="item.img" fit="cover" @click="view(k)" />
                <div class="desc">
                  {{ item.description }}
                </div>
              </div>
            </div>
          </div>
          <!-- <a
              href="https://work.weixin.qq.com/kfid/kfca7acc7eceb85b855"
              target="_blank"
            >
              <img
                src="/img/qrcode_l.jpg"
                class="album-pic"
                style="width: 19%"
              />
            </a>
            <a href="/img/qrcode_r.jpg" target="_blank">
              <img
                src="/img/qrcode_r.jpg"
                class="album-pic"
                style="width: 63%"
              />
            </a> -->

          <div class="promotion" v-show="newData.promotion.length > 0">
            <a
              href="https://work.weixin.qq.com/kfid/kfcb6cdc69643021bbb"
              target="_blank"
              >点击加群 回复“<span style="color: #f00">{{
                newData.promotion[0]
              }}</span
              >”<br />
              &nbsp; 加入“<span style="color: #f00">{{
                newData.promotion[1]
              }}</span
              >”</a
            >
          </div>
        </div>
        <van-swipe
          class="my-swipe"
          :autoplay="1000000"
          style="height: 200px"
          indicator-color="white"
          v-if="showRelatedNews"
        >
          <van-swipe-item v-for="(item, k) in headline" :key="k">
            <div class="thumb" @click="goView(item.id, item.type)">
              <van-image :src="item.titleImgUrl"></van-image>
              <div class="title">{{ item.title }}</div>
            </div>
          </van-swipe-item>
        </van-swipe>
      </div>
      <div class="error" v-if="error">
        <van-empty :description="errorT" />
      </div>

      <!-- <div class="line1"></div> -->
      <div>
        <div class="newsList" v-if="showRelatedNews">
          <div class="lable-title"><span>热点推荐</span></div>

          <div class="error" v-if="error2">
            <van-empty :description="error2T" />
          </div>
          <div v-if="!loading2" style="padding-top: 10px">
            <div
              class="news-item"
              v-for="(v, k) in relatedNewsData"
              :key="k"
              @click="goView(v.id, v.type)"
            >
              <div class="right-content">
                <a class="subject" href="">{{ v.title }}</a>
              </div>
              <div class="thumb">
                <van-image :src="v.gallery[0]"></van-image>
              </div>
            </div>
          </div>
          <div v-if="loading2">
            <div class="loading">
              <van-loading type="circular" color="#999" />
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="copyright">
      <p>
        <a href="https://www.scsjb.cn">四川手机报</a
        ><a href="https://www.mala.cn">麻辣社区</a
        ><a href="http://www.newssc.org/">四川新闻网</a>
      </p>
      <!-- <p>Copyright © 2021 - 四川手机报</p> -->
      <p>
        Copyright © 2021 - 四川手机报<br />蜀ICP备12003267号-1<br />互联网新闻信息服务许可证编号:51120170002
      </p>
    </section>
    <van-action-sheet v-model="bottomPannel" close-on-click-action>
      <van-picker
        show-toolbar
        title="字体大小"
        :columns="columns"
        :default-index="defaultIndex"
        @confirm="onChangeFontSizeConfirm"
        @cancel="onChangeFontSizeCancel"
        onClick
      />
    </van-action-sheet>
  </div>
</template>

<script>
import { isWechat, wechatShare } from "../commJs/wechat";
import { getView, getList, getTonglan, getRelatedNews } from "../commJs/api";
import { ImagePreview } from "vant";

export default {
  data() {
    return {
      showRelatedNews: true,
      loading: true,
      error: false,
      rankData: [],
      relatedNewsData: [],
      errorT: "",
      fontSize: localStorage.getItem("fontSize") || "20",
      id: 0,
      loading2: true,
      newData: [],
      error2: false,
      error2T: "",
      headline: [],
      today: null,
      channelId: 0,
      title: "",
      bottomPannel: false,
      defaultIndex: 0,
      columns: [
        { text: "小", value: 16 },
        { text: "标准", value: 20 },
        { text: "大", value: 24 },
        { text: "特大", value: 28 },
      ],
    };
  },
  methods: {
    loadVideo() {
      this.$nextTick(() => {
        const videos = document.querySelectorAll(".message video");
        videos.forEach((video) => {
          video.currentTime = 0.1;
        });
      });
    },
    getDefaultIndex() {
      let index = 0;
      if (this.fontSize == 10) {
        index = 0;
      }
      if (this.fontSize == 20) {
        index = 1;
      }
      if (this.fontSize == 24) {
        index = 2;
      }
      if (this.fontSize == 28) {
        index = 3;
      }
      return index;
    },
    openBottomPannel() {
      this.defaultIndex = this.getDefaultIndex();
      this.bottomPannel = true;
    },
    onChangeFontSizeConfirm(value) {
      this.fontSize = value.value;
      localStorage.setItem("fontSize", value.value);
      this.bottomPannel = false;
    },
    onChangeFontSizeCancel() {
      // this.fontSize = this.previousFontSize;
      // localStorage.setItem("fontSize", this.previousFontSize);
      this.bottomPannel = false;
    },
    goThumb(id) {
      this.$router.push({ name: "detail", params: { id: id } });
      if (isWechat) {
        wechatShare();
      } else {
        wechatShare();
      }
    },
    goView(id, t) {
      if (t == 1 || t == 3) {
        this.$router.push({ name: "detail", params: { id: id } });
      } else if (t == 4) {
        this.$router.push({ name: "live", params: { id: id } });
      } else if (t == 2) {
        this.$router.push({ name: "special", params: { id: id } });
      } else {
        this.$router.push({ name: "detail", params: { id: id } });
      }
    },
    getIndex() {},
    view(i) {
      let imgs = [];
      for (let v in this.newData.content) {
        imgs = imgs.concat(this.newData.content[v].img);
      }
      ImagePreview({
        images: imgs,
        startPosition: i,
      });
    },
    // setfontSize(type) {
    //   let fontSize = this.fontSize || localStorage.getItem("fontSize");
    //   if (type === 1) {
    //     this.fontSize = parseInt(fontSize) + 2;
    //   } else {
    //     this.fontSize = parseInt(fontSize) - 2;
    //   }
    //   localStorage.setItem("fontSize", this.fontSize);
    // },
    getFontsize() {
      this.fontSize =
        localStorage.getItem("fontSize") ||
        localStorage.setItem("fontSize", 20);
    },
    getView(id) {
      getView({ newsId: id }).then((res) => {
        if (res.code == 200) {
          if (res.data.news.outLink) {
            window.location.replace(res.data.news.outLink);
          } else {
            this.newData = res.data.news;
            this.loading = false;
            this.title = res.data.news.title;
            document.title = res.data.news.title;
            this.today = res.data.news.publishTime.substr(0, 10);
            this.channelId = res.data.news.channelId;
            if (
              (res.data.news.showRelatedNews == 1) &
              (res.data.news.keyword == "")
            ) {
              this.showRelatedNews = 0;
            } else {
              this.getRelatedNewsList(id);
            }
            wechatShare(res.data.news.title);
            if (this.newData.type == 5 || this.newData.type == 1) {
              this.$nextTick(() => {
                this.loadVideo();
              });
            }
          }
        }
      });
    },
    onClickLeft() {
      this.$router.push({ name: "channe", params: { id: this.channelId } });
    },
    onClickRight() {
      window.open("https://www.scsjb.cn/other/smsplan", "_blank");
    },
    getRelatedNewsList(newsId) {
      let _this = this;
      getTonglan({ channelId: "1000211", count: 3 }).then((res) => {
        if (res.code == 200) {
          _this.headline = res.data.headline;
        }
      });
      if (_this.newData.showRelatedNews == 1) {
        getRelatedNews({ newsId: newsId }).then((res) => {
          if (res.code == 200) {
            let validList = [];
            for (let i in res.data.newsList) {
              validList.push(res.data.newsList[i]);
              // if (res.data.newsList[i].isTop !== 1) {
              //   validList.push(res.data.newsList[i]);
              // }
            }
            _this.relatedNewsData = validList;
            _this.loading2 = false;
          }
        });
      } else {
        getList({ channelId: "1000211", count: 7 }).then((res) => {
          if (res.code == 200) {
            let validList = [];
            for (let i in res.data.newsList) {
              if (res.data.newsList[i].isTop !== 1) {
                validList.push(res.data.newsList[i]);
              }
            }
            _this.relatedNewsData = validList;
            _this.loading2 = false;
          }
        });
      }
    },
  },
  watch: {
    $route: function () {
      this.loading = true;
      this.newData = "";
      this.id = this.$route.params.id || 0;
      if (!this.id || this.id == 0) {
        this.error = "该文章不存在";
      } else {
        this.getView(this.id);
      }
    },
  },
  mounted() {
    this.id = this.$route.params.id || 0;
    if (!this.id || this.id == 0) {
      this.error = "该文章不存在";
    } else {
      this.getView(this.id);
    }
    this.getFontsize();
  },
};
</script>
<style lang="less">
.van-nav-bar {
  padding-left: 14px;
  padding-right: 14px;
}
.van-nav-bar__arrow {
  font-size: 16px !important;
}

.van-nav-bar__text {
  font-size: 13px !important;
  color: #666 !important;
}

.van-nav-bar .van-icon {
  color: #999 !important;
}

.album-pic {
  width: 100%;
}
.scsjb_info {
  display: flex;
  align-items: center;
}
.author {
  width: 70px;
  height: 60px;
  .dlogo {
    width: 60px;
  }
}

.user_info {
  .n {
    color: #666;
    font-size: 16px;
    //font-weight: bold;
  }
  .t {
    margin-top: 5px;
    color: #bdbbbb;
    font-size: 13px;
  }
}
.photocentent {
  .imgs {
    background: #eee;
    margin-bottom: 20px;

    .desc {
      color: #666;
      font-size: 14px;
      padding: 0 10px 10px 10px;
    }
  }
}

.message {
  p {
    margin: 0;
    padding: 10px 30px 10px 30px !important;
    video {
      margin-left: -30px;
      width: calc(100% + 60px);
    }
  }

  .my-img {
    padding: 10px 0px 10px 0px !important;
    img {
      width: 100%;
      padding-top: 10px;
      max-width: 100%;
      height: auto !important;
    }
  }
}

.copyright {
  text-align: center;
  padding: 15px 0;
  background: #f7f8fa;
  color: #a8abb0;
  font-size: 12px;

  p:first-child {
    display: flex;
    width: 80%;
    margin: 0 auto;
    justify-content: space-around;

    a {
      color: rgba(0, 0, 0, 0.45);
    }
  }

  p:last-child {
    color: rgba(0, 0, 0, 0.25);
  }
}

.van-skeleton {
  padding: 0 !important;

  .van-skeleton__title {
    height: 30px !important;
    width: 70%;
    margin: 5px 0 30px;
  }

  .van-skeleton__row {
    height: 22px !important;
  }
}
</style>
<style scoped lang="less">
.my-swipe {
  // padding: 10px 10px 0 10px;
  // width: calc(100% - 20px);
  width: 100%;
  overflow: hidden;
  padding-top: 10px;
  margin-top: 30px;
}

.my-swipe .thumb {
  position: relative;
  height: 200px;
  // width: calc(100% - 20px);
  overflow: hidden;

  &:after {
    content: "";
    position: absolute;
    width: 100%;
    height: 80px;
    left: 0;
    bottom: 0;
    background-color: transparent;
    background: -webkit-gradient(
      linear,
      left top,
      left bottom,
      from(transparent),
      to(#000)
    );
    background: -webkit-linear-gradient(top, transparent, #000);
    background: -moz-linear-gradient(top, transparent, #000);
    background: -ms-linear-gradient(top, transparent, #000);
    opacity: 0.6;
  }

  .title {
    color: #fff;
    position: absolute;
    bottom: 20px;
    z-index: 1111;
    left: 10px;
    font-size: 18px;
    width: calc(100 - 20px);
  }
}
.newsList {
  // padding: 15px;
  background: #f8f8f8;
  padding: 15px 30px 0 30px !important;

  .lable-title {
    color: #164a9a;
    font-size: 18px;
    font-weight: bold;
    padding-bottom: 10px;
    border-bottom: 1px solid #eee;

    span {
      position: relative;

      &:after {
        width: 100%;
        position: absolute;
        content: "";
        height: 2px;
        background: #164a9a;
        left: 50%;
        transform: translateX(-50%);
        bottom: -12px;
      }
    }
  }
}

.contents {
  // background: #fff !important;
  background: #f8f8f8 !important;

  // .qrcode {
  //   padding: 0px 30px 0 30px !important;
  //   display: inline;
  // }
  .origin {
    color: #999;
    margin: 0 30px 20px auto;
    text-align: right;
  }
  .promotion {
    margin: 0 auto;
    width: 70%;
    text-align: center;
    font-size: 16px;
  }
  .views {
    float: right;
    font-size: 12px;
    padding-right: 30px;
    padding-top: 52px;
  }
  .thread-star {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 30px 10px 30px !important;

    .time {
      font-size: 16px;
      color: #999;

      .user_info .n {
        font-size: 14px;
      }
      .user_info .t {
        font-size: 12px;
      }
    }

    .mode {
      display: flex;
      margin: 10px 0;

      .fontSize {
        &:first-child {
          border-top-left-radius: 30px;
          border-bottom-left-radius: 30px;
          position: relative;

          &:before {
            content: "";
            height: 15px;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            right: 0;
            width: 1px;
            background: #efeaeab8;
          }
        }

        &:last-child {
          border-top-right-radius: 30px;
          border-bottom-right-radius: 30px;
        }

        // width: 60px;
        width: 40px;
        height: 30px;
        line-height: 20px;
        text-align: center;
        color: #3763a8;
        background: #f9f8f8;

        .iconfont {
          font-size: 20px;
        }
      }
    }
  }

  .h2subject {
    line-height: 36px;
    font-size: 28px;
    color: #1a1a1a;
    // font-family: PingFangSC-Medium;
    font-weight: bold;
    padding: 15px 30px 0 30px !important;
  }

  .message {
    font-size: 20px;
    line-height: 34px;
    text-align: justify;
    padding-top: 0px;
    color: rgb(34, 34, 34);
    p {
      // padding-right: 5px;
      // padding-left: 5px;
      margin: 10px 0;
      &:first-child {
        margin-top: 0;
      }
    }
  }
}
</style>